(function () {
  if (window.medSpaServicePopupInitialized) {
    return;
  }

  window.medSpaServicePopupInitialized = true;

  let activePopup = null;
  let activeTrigger = null;

  function getFocusableElements(container) {
    const selector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    return Array.from(container.querySelectorAll(selector)).filter(
      function (element) {
        return !element.hidden && element.offsetParent !== null;
      }
    );
  }

  function initializeSlider(slider) {
    if (!slider || slider.dataset.sliderInitialized === 'true') {
      return;
    }

    slider.dataset.sliderInitialized = 'true';

    const slides = Array.from(
      slider.querySelectorAll('[data-popup-slide]')
    );

    const dots = Array.from(
      slider.querySelectorAll('[data-popup-slider-dot]')
    );

    const previousButton = slider.querySelector(
      '[data-popup-slider-previous]'
    );

    const nextButton = slider.querySelector(
      '[data-popup-slider-next]'
    );

    let currentIndex = 0;

    function showSlide(index) {
      if (!slides.length) {
        return;
      }

      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === currentIndex;

        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach(function (dot, dotIndex) {
        const isActive = dotIndex === currentIndex;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute(
          'aria-current',
          isActive ? 'true' : 'false'
        );
      });
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        showSlide(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const targetIndex = Number(
          dot.getAttribute('data-popup-slider-dot')
        );

        showSlide(targetIndex);
      });
    });

    slider.resetPopupSlider = function () {
      showSlide(0);
    };

    showSlide(0);
  }

  function initializeAllSliders(scope) {
    const container = scope || document;

    container
      .querySelectorAll('[data-popup-slider]')
      .forEach(function (slider) {
        initializeSlider(slider);
      });
  }

  function openPopup(popup, trigger) {
    if (!popup) {
      return;
    }

    if (activePopup && activePopup !== popup) {
      closePopup();
    }

    activePopup = popup;
    activeTrigger = trigger;

    popup.hidden = false;
    popup.classList.add('is-open');

    document.body.classList.add('med-spa-popup-open');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'true');
    }

    const slider = popup.querySelector('[data-popup-slider]');

    if (
      slider &&
      typeof slider.resetPopupSlider === 'function'
    ) {
      slider.resetPopupSlider();
    }

    const modal = popup.querySelector(
      '.med-spa-popup__modal'
    );

    window.requestAnimationFrame(function () {
      if (modal) {
        modal.focus();
      }
    });
  }

  function closePopup() {
    if (!activePopup) {
      return;
    }

    activePopup.classList.remove('is-open');
    activePopup.hidden = true;

    document.body.classList.remove('med-spa-popup-open');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus();
    }

    activePopup = null;
    activeTrigger = null;
  }

  function trapFocus(event) {
    if (!activePopup || event.key !== 'Tab') {
      return;
    }

    const focusableElements =
      getFocusableElements(activePopup);

    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement =
      focusableElements[focusableElements.length - 1];

    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(
      '[data-med-spa-service-trigger]'
    );

    if (trigger) {
      const popupId =
        trigger.getAttribute('data-popup-target');

      const popup = document.getElementById(popupId);

      openPopup(popup, trigger);
      return;
    }

    if (
      activePopup &&
      event.target.closest('[data-popup-close]')
    ) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activePopup) {
      closePopup();
      return;
    }

    trapFocus(event);
  });

  function initialize() {
    initializeAllSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllSliders(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      if (
        activePopup &&
        event.target.contains(activePopup)
      ) {
        closePopup();
      }
    }
  );
})();